module.exports = __webpack_public_path__ + "static/media/ExoBNNVARA-Medium.93b98a11.woff";